import { render, staticRenderFns } from "./EDatePickerCalendarioLetivo.vue?vue&type=template&id=c4457186&scoped=true"
import script from "./EDatePickerCalendarioLetivo.vue?vue&type=script&lang=js"
export * from "./EDatePickerCalendarioLetivo.vue?vue&type=script&lang=js"
import style0 from "./EDatePickerCalendarioLetivo.vue?vue&type=style&index=0&id=c4457186&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4457186",
  null
  
)

export default component.exports